/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2016, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./FilterBaseView',
	'underscore'
],
function(View, _) {
	'use strict';

	var NonNumericFilterView = View.extend({
		reactViewClass: 'NonNumericFilter',
		compactReactViewClass: 'CompactNonNumericFilter',

		init: function() {
			NonNumericFilterView.inherited('init', this, arguments);
		},

		_getCommonViewProps: function() {
			var currentValues = this.model.toJSON();
			var selectedValuesCount = _.size(currentValues.selectedMembers);
			var props = {
				title: currentValues.name,
				inverted: currentValues.inverted,
				filterSelectionType: 'member',
				locale: this.locale,
				totalValues: (this.model.list.length || 0),
				selectedValuesCount: selectedValuesCount,
				showCondition: (this.options.showCondition || false),
				showToggle: this.options.showToggle,
				allowSearch: this.options.allowSearch !== undefined ? this.options.allowSearch : true, // Disable search if explicitly told to.
				isToggled: currentValues.isToggled,
				condition: currentValues.condition,
				loading: this.loading
			};
			return props;
		},

		_getCommonViewCallbacks: function() {
			return {
				onClear: this._onClear.bind(this),
				onChange: this._onChange.bind(this),
				onClick: this._onClick.bind(this),
				onSearch: this._onSearch.bind(this),
				onDone: this._onDone.bind(this),
				onApply: this._onApply.bind(this),
				onClose: this._onClose.bind(this),
				getValue: this._getValue.bind(this),
				onToggleChange: this._onToggleChange.bind(this)
			};
		}

	});
	return NonNumericFilterView;
});
